import './home.styles.scss';
import Header from '../../components/header/header.component';
import Category from '../../components/category/category.component';
import NavDropdown from '../../components/nav-dropdown/nav-dropdown.component';
import ValuesImage from '../../assets/values-bg.png';
const Home = () => {

    return (
        <div className='home-container'>
            <Header/>

            {/* <Category/> */}

        </div>
    )
}


export default Home;